import { INFT } from '../types/nft';
import { NFTMetadata } from '../types/dto/UserNFTs.dto';
import { BigNumber } from 'ethers';
import { parseEther } from 'ethers/lib/utils';

export const getIdsAndAddressesAndAmounts = (
  nfts: INFT[],
): { addresses: string[]; ids: string[]; amounts: string[] } => {
  const addresses: string[] = [];
  const ids: string[] = [];
  const amounts: string[] = [];
  nfts.forEach((nft) => {
    addresses.push(nft.contractAddress);
    ids.push(nft.tokenId.toString());
    if (nft.type === 'ERC721') {
      amounts.push('0'); // contraxts expects 0 amount for erc721 tokens
    } else {
      amounts.push(nft.amount);
    }
  });

  return {
    addresses,
    ids,
    amounts,
  };
};

export const getMetadataImage = (metadata?: NFTMetadata): string => {
  const defaultImage = '';
  // TODO: Default image
  if (!metadata) {
    return defaultImage;
  }
  return (metadata.image ?? metadata.image_url ?? metadata['image_data']) || defaultImage;
};

export const getAreNFTsVerified = (nfts: INFT[], verifiedAddresses: string[]): INFT[] =>
  nfts.map((nft) => ({
    verified: nft.verified || verifiedAddresses.includes(nft.contractAddress.toLowerCase()),
    ...nft,
  }));

export const getFeePlusEthAmount = (fee: BigNumber, ethAmount: number | undefined): BigNumber => {
  if (!!ethAmount) {
    return fee.add(parseEther(ethAmount.toString()));
  } else return fee;
};

export const parseEthAmount = (ethAmount: string | number | undefined): number | undefined => {
  if (typeof ethAmount === 'string') return parseFloat(ethAmount);
  return ethAmount;
};
